var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-width slide-y fill-height floating-channel-list"},_vm._l((_vm.channelsList),function(channel){return _c('ChannelItem',{key:channel.channelSid,attrs:{"active":channel.sid === _vm.selectedChannelSid,"channel":channel},nativeOn:{"click":function($event){return _vm.selectChannel(channel)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }